module.exports = __webpack_public_path__ + "img/online-step-1.9172f048.png";